export default {
  "brand.name": "AllChinaBuy Spreadsheet",
  "brand.tagline": "Produktforskning & QC",

  "nav.home": "Hjem",
  "nav.shoppingGuide": "Købsguide",
  "nav.categories": "Kategorier",
  "nav.qc": "QC-fotos",
  "nav.shipping": "Forsendelse",
  "nav.review": "Anmeldelse",
  "nav.safety": "Sikkerhed",
  "nav.buyNow": "Køb nu",

  "lang.en": "English",
  "lang.fr": "Français",
  "lang.da": "Dansk",
  "lang.de": "Deutsch",

  "hero.badge": "Uafhængig ressource · Opdateret 2026",
  "hero.title": "AllChinaBuy Spreadsheet — Find produkter, QC-fotos og bedre købsguides",
  "hero.subtitle": "Udforsk AllChinaBuy-regneark, produktfund, QC-oplysninger, forsendelsesguides, lagertips, kuponer og sikkerhedsressourcer samlet ét sted.",
  "hero.ctaExplore": "AllChinaBuy Spreadsheet",
  "hero.ctaBuyNow": "Køb nu",
  "hero.searchPlaceholder": "Søg i AllChinaBuy-regneark, produkter, QC eller forsendelse...",
  "hero.dropdownLabel": "Gennemse produktkategorier",
  "hero.noResults": "Ingen kategorier fundet",

  "categories.title": "Populære produktkategorier",
  "categories.subtitle": "Gå direkte til enhver produktkategori på hovedsiden AllChinaBuy Spreadsheet.",
  "categories.shoes": "Sko",
  "categories.hoodies": "Hættetrøjer / Sweatshirts",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jakker",
  "categories.pants": "Bukser / Shorts",
  "categories.headwear": "Hovedbeklædning",
  "categories.sets": "Sæt",
  "categories.underwear": "Undertøj / Underbukser",
  "categories.jersey": "Trøjer",
  "categories.accessories": "Tilbehør",
  "categories.bags": "Tasker",
  "categories.belts": "Bælter",
  "categories.perfumes": "Parfumer",
  "categories.other": "Andre ting",

  "what.title": "Hvad er et AllChinaBuy Spreadsheet?",
  "what.body": "Et AllChinaBuy-regneark er et delt, organiseret ark, der samler produktlinks, priser, størrelser, QC-fotos og forsendelsesnoter for de varer, du vil købe via AllChinaBuy. I stedet for at jonglere med snesevis af browserfaner holder du alt samlet ét sted — hvilket gør research, bestilling og kvalitetstjek langt nemmere.",

  "qc.title": "QC-fotos & kvalitetsguide",
  "qc.body": "Kvalitetskontrol-fotos lader dig inspicere en vare, før den sendes. Et godt regneark sporer QC-fotolinks, mål og eventuelle fejl, så du kan bekræfte, at produktet matcher annoncen, før du betaler for international forsendelse.",

  "shipping.title": "AllChinaBuy forsendelsesomkostningsguide",
  "shipping.body": "Forsendelsesomkostningerne afhænger af pakkens vægt, volumen og den valgte forsendelseslinje. Et velstruktureret regneark registrerer estimeret vægt, linjemuligheder og endelig pris for hvert haul, så du kan lægge et budget og vælge den mest økonomiske rute til dit land.",

  "review.title": "AllChinaBuy anmeldelse & tillid",
  "review.body": "Vi opsummerer virkelige erfaringer, fordele og ulemper, leveringstider og kvaliteten af kundesupport. Bekræft altid gældende vilkår og politikker på den officielle AllChinaBuy-platform, før du træffer beslutninger.",

  "safety.title": "Sikkerhedscenter",
  "safety.body": "Undgå falske regneark og mistænkelige links. Brug kun pålidelige kilder, tjek sælgere, forstå told- og skatteregler, og del aldrig betalingsoplysninger uden for officielle kanaler.",

  "articles.title": "Seneste guides & artikler",
  "articles.subtitle": "Originale, dybdegående SEO-guides skrevet omkring AllChinaBuy Spreadsheet-temaet.",
  "articles.card.title": "AllChinaBuy Spreadsheet: Den komplette 2026-guide",
  "articles.card.excerpt": "Lær, hvad et AllChinaBuy-regneark er, hvordan du bruger det til produktresearch og QC, hvad forsendelse virkelig koster, og om AllChinaBuy er sikkert og legitimt.",
  "articles.card.readMore": "Læs guiden",
  "articles.card.meta": "Guide · 8 min læsning",

  "faq.title": "Ofte stillede spørgsmål",
  "faq.q1": "Er AllChinaBuy legitimt?",
  "faq.a1": "AllChinaBuy er en velkendt indkøbsagent. Brug altid det officielle websted og tjek politikkerne, før du bestiller. Dette uafhængige site er ikke den officielle platform.",
  "faq.q2": "Hvor meget koster AllChinaBuy-forsendelse?",
  "faq.a2": "Prisen afhænger af vægt, volumen og den valgte linje. Lettere, mindre pakker og økonomilinjer koster normalt mindre.",
  "faq.q3": "Hvad er et AllChinaBuy-regneark?",
  "faq.a3": "Det er et delt ark, der organiserer produktlinks, priser, QC-fotos og forsendelsesnoter for varerne i dit haul.",
  "faq.q4": "Tilbyder AllChinaBuy QC-fotos?",
  "faq.a4": "Ja, QC-fotos er tilgængelige for mange ordrer, så du kan inspicere varer, før de sendes internationalt.",
  "faq.q5": "Hvordan finder jeg AllChinaBuy-kuponer eller rabatkoder?",
  "faq.a5": "Tjek det officielle site og pålidelige fællesskaber for aktuelle tilbud. Vi offentliggør ikke ubekræftede kuponer eller kampagner.",

  "final.title": "Klar til at udforske AllChinaBuy Spreadsheet?",
  "final.subtitle": "Åbn det fulde regneark for at gennemse produkter, tjekke QC-fotos og planlægge dit næste haul.",
  "final.button": "Åbn AllChinaBuy Spreadsheet",

  "footer.disclaimer": "AllChinaBuySpread.uk er en uafhængig informationsressource og er ikke det officielle AllChinaBuy-websted. Oplysninger kan ændres. Bekræft aktuelle priser, kampagner, forsendelsesregler og politikker, før du træffer beslutninger.",
  "footer.rights": "Alle rettigheder forbeholdes.",
  "footer.guide": "Spreadsheet-guide",
  "footer.home": "Hjem",
}